import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class OrderResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/orders' as const

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}